export enum BillingFrequency {
  Weekly = 'weekly',
  Every10Days = 'every_10_days',
  Every15Days = 'every_15_days',
  Monthly = 'monthly',
};

export namespace BillingFrequency {
  export const translateType = (type: BillingFrequency): string => {
    switch (type) {
      case BillingFrequency.Weekly:
        return "Semanal"
      case BillingFrequency.Every10Days:
        return "A cada 10 dias";
      case BillingFrequency.Every15Days:
        return "A cada 15 dias";
      case BillingFrequency.Monthly:
        return "Mensal";
      default: return "";
    };
  };

  export const billingFrequencyChoices: Array<{ id: string, name: string }> = Object.values(BillingFrequency)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: BillingFrequency.translateType(type as BillingFrequency),
    } as { id: string, name: string }));
};